import { schema } from 'normalizr'

export default new schema.Entity(
    'competitionLayouts',
    {},
    {
        idAttribute: 'competition',
        processStrategy: layout => ({
            // Meta.
            _type: 'layout',
            // Fields.
            ...layout,
        }),
    }
)
